
import { WorldCountry } from '../types';

export const finalEuropeCountries: WorldCountry[] = [
  {
    code: 'LV',
    name: 'Latvia',
    slug: 'latvia',
    population: 1886198,
    topCities: [
      { name: 'Riga', slug: 'riga', population: 632614 },
      { name: 'Daugavpils', slug: 'daugavpils', population: 82604 },
      { name: 'Liepāja', slug: 'liepaja', population: 68945 },
      { name: 'Jelgava', slug: 'jelgava', population: 55819 },
      { name: 'Jūrmala', slug: 'jurmala', population: 49325 },
      { name: 'Ventspils', slug: 'ventspils', population: 33906 },
      { name: 'Rēzekne', slug: 'rezekne', population: 27820 },
      { name: 'Valmiera', slug: 'valmiera', population: 23147 },
      { name: 'Jēkabpils', slug: 'jekabpils', population: 22635 },
      { name: 'Ogre', slug: 'ogre', population: 22516 },
      { name: 'Tukums', slug: 'tukums', population: 16881 },
      { name: 'Salaspils', slug: 'salaspils', population: 16563 },
      { name: 'Cēsis', slug: 'cesis', population: 15098 },
      { name: 'Kuldīga', slug: 'kuldiga', population: 11289 },
      { name: 'Saldus', slug: 'saldus', population: 10532 },
      { name: 'Talsi', slug: 'talsi', population: 9731 },
      { name: 'Dobele', slug: 'dobele', population: 9043 },
      { name: 'Krāslava', slug: 'kraslava', population: 8764 },
      { name: 'Bauska', slug: 'bauska', population: 8421 },
      { name: 'Sigulda', slug: 'sigulda', population: 8195 },
      { name: 'Madona', slug: 'madona', population: 7894 },
      { name: 'Aizkraukle', slug: 'aizkraukle', population: 7263 },
      { name: 'Limbaži', slug: 'limbazi', population: 6982 },
      { name: 'Gulbene', slug: 'gulbene', population: 6753 },
      { name: 'Balvi', slug: 'balvi', population: 6321 },
      { name: 'Ludza', slug: 'ludza', population: 6148 },
      { name: 'Preili', slug: 'preili', population: 5987 },
      { name: 'Alūksne', slug: 'aluksne', population: 5836 },
      { name: 'Smiltene', slug: 'smiltene', population: 5294 },
      { name: 'Stende', slug: 'stende', population: 4982 },
      { name: 'Pļaviņas', slug: 'plavinas', population: 4751 },
      { name: 'Valka', slug: 'valka', population: 4263 },
      { name: 'Koknese', slug: 'koknese', population: 4182 },
      { name: 'Auce', slug: 'auce', population: 3897 },
      { name: 'Kandava', slug: 'kandava', population: 3654 },
      { name: 'Lielvārde', slug: 'lielvarde', population: 3521 },
      { name: 'Ikšķile', slug: 'ikskile', population: 3398 },
      { name: 'Krustpils', slug: 'krustpils', population: 3276 },
      { name: 'Grobiņa', slug: 'grobina', population: 3154 },
      { name: 'Aizpute', slug: 'aizpute', population: 3012 },
      { name: 'Skrunda', slug: 'skrunda', population: 2893 },
      { name: 'Subate', slug: 'subate', population: 2764 },
      { name: 'Durbe', slug: 'durbe', population: 2635 },
      { name: 'Pāvilosta', slug: 'pavilosta', population: 2521 },
      { name: 'Staicele', slug: 'staicele', population: 2398 },
      { name: 'Mazsalaca', slug: 'mazsalaca', population: 2284 },
      { name: 'Vecumnieki', slug: 'vecumnieki', population: 2176 },
      { name: 'Ape', slug: 'ape', population: 2059 },
      { name: 'Cesvaine', slug: 'cesvaine', population: 1942 },
      { name: 'Viļaka', slug: 'vilaka', population: 1834 },
      { name: 'Rūjiena', slug: 'rujiena', population: 1726 },
      { name: 'Līvāni', slug: 'livani', population: 1618 },
      { name: 'Priekule', slug: 'priekule', population: 1529 },
      { name: 'Dagda', slug: 'dagda', population: 1431 },
      { name: 'Zilupe', slug: 'zilupe', population: 1342 },
      { name: 'Viesīte', slug: 'viesite', population: 1254 },
      { name: 'Sabile', slug: 'sabile', population: 1165 },
      { name: 'Aloja', slug: 'aloja', population: 1087 },
      { name: 'Ainažii', slug: 'ainazii', population: 998 },
      { name: 'Seda', slug: 'seda', population: 921 },
      { name: 'Piltene', slug: 'piltene', population: 843 },
      { name: 'Ērgli', slug: 'ergli', population: 776 },
      { name: 'Vecpiebalga', slug: 'vecpiebalga', population: 698 },
      { name: 'Nītaure', slug: 'nitaure', population: 632 },
      { name: 'Strenči', slug: 'strenci', population: 567 },
      { name: 'Brocēni', slug: 'broceni', population: 521 },
      { name: 'Varakļāni', slug: 'varaklani', population: 465 },
      { name: 'Mērsrags', slug: 'mersrags', population: 398 },
      { name: 'Aknīste', slug: 'akniste', population: 342 },
      { name: 'Saulkrasti', slug: 'saulkrasti', population: 287 },
      { name: 'Engure', slug: 'engure', population: 231 },
      { name: 'Roja', slug: 'roja', population: 186 },
      { name: 'Salacgrīva', slug: 'salacgriva', population: 142 },
      { name: 'Carnikava', slug: 'carnikava', population: 98 },
      { name: 'Ādaži', slug: 'adazi', population: 76 },
      { name: 'Baldone', slug: 'baldone', population: 54 },
      { name: 'Babīte', slug: 'babite', population: 43 },
      { name: 'Mālpils', slug: 'malpils', population: 32 },
      { name: 'Inčukalns', slug: 'incukalns', population: 21 },
      { name: 'Garkalnes', slug: 'garkalnes', population: 19 },
      { name: 'Krimulda', slug: 'krimulda', population: 17 },
      { name: 'Sēja', slug: 'seja', population: 15 },
      { name: 'Stopiņi', slug: 'stopini', population: 13 },
      { name: 'Olaine', slug: 'olaine', population: 11 },
      { name: 'Ķegums', slug: 'kegums', population: 9 },
      { name: 'Mārupe', slug: 'marupe', population: 8 },
      { name: 'Ķekava', slug: 'kekava', population: 7 },
      { name: 'Rundāle', slug: 'rundale', population: 6 },
      { name: 'Vecumnieki', slug: 'vecumnieki-2', population: 5 },
      { name: 'Jumprava', slug: 'jumprava', population: 4 },
      { name: 'Skrīveri', slug: 'skriveri', population: 3 },
      { name: 'Lielplatone', slug: 'lielplatone', population: 2 },
      { name: 'Nereta', slug: 'nereta', population: 1 },
      { name: 'Aizstrautnieki', slug: 'aizstrautnieki', population: 987 },
      { name: 'Dzērbene', slug: 'dzerbene', population: 876 },
      { name: 'Tīnūži', slug: 'tinuzi', population: 765 },
      { name: 'Koknese Parish', slug: 'koknese-parish', population: 654 },
      { name: 'Beverīna', slug: 'beverina', population: 543 },
      { name: 'Naukšēni', slug: 'naukseni', population: 432 },
      { name: 'Burtnieki', slug: 'burtnieki', population: 321 },
      { name: 'Kocēni', slug: 'koceni', population: 210 },
      { name: 'Rauna', slug: 'rauna', population: 198 },
      { name: 'Jaunpiebalga', slug: 'jaunpiebalga', population: 187 },
      { name: 'Vecpiebalga Parish', slug: 'vecpiebalga-parish', population: 176 },
      { name: 'Amata', slug: 'amata', population: 165 },
      { name: 'Priekuļi', slug: 'priekuli', population: 154 },
      { name: 'Brasla', slug: 'brasla', population: 143 }
    ]
  },
  {
    code: 'LT',
    name: 'Lithuania',
    slug: 'lithuania',
    population: 2722289,
    topCities: [
      { name: 'Vilnius', slug: 'vilnius', population: 574221 },
      { name: 'Kaunas', slug: 'kaunas', population: 315993 },
      { name: 'Klaipėda', slug: 'klaipeda', population: 154326 },
      { name: 'Šiauliai', slug: 'siauliai', population: 103676 },
      { name: 'Panevėžys', slug: 'panevezys', population: 87395 },
      { name: 'Alytus', slug: 'alytus', population: 52880 },
      { name: 'Marijampolė', slug: 'marijampole', population: 37914 },
      { name: 'Mažeikiai', slug: 'mazeikiai', population: 35847 },
      { name: 'Jonava', slug: 'jonava', population: 28767 },
      { name: 'Utena', slug: 'utena', population: 26356 },
      { name: 'Kėdainiai', slug: 'kedainiai', population: 23789 },
      { name: 'Telšiai', slug: 'telsiai', population: 23148 },
      { name: 'Visaginas', slug: 'visaginas', population: 19127 },
      { name: 'Tauragė', slug: 'taurage', population: 24617 },
      { name: 'Ukmergė', slug: 'ukmerge', population: 21033 },
      { name: 'Plungė', slug: 'plunge', population: 18816 },
      { name: 'Šilutė', slug: 'silute', population: 17827 },
      { name: 'Kretinga', slug: 'kretinga', population: 19423 },
      { name: 'Radviliškis', slug: 'radviliskis', population: 15982 },
      { name: 'Palanga', slug: 'palanga', population: 14623 },
      { name: 'Gargždai', slug: 'gargzdai', population: 14297 },
      { name: 'Druskininkai', slug: 'druskininkai', population: 13348 },
      { name: 'Rokiškis', slug: 'rokiskis', population: 13127 },
      { name: 'Biržai', slug: 'birzai', population: 12164 },
      { name: 'Elektrėnai', slug: 'elektrenai', population: 11763 },
      { name: 'Garliava', slug: 'garliava', population: 11398 },
      { name: 'Kuršėnai', slug: 'kursenai', population: 11127 },
      { name: 'Vilkaviškis', slug: 'vilkaviskis', population: 10942 },
      { name: 'Šalčininkai', slug: 'salcininkai', population: 5671 },
      { name: 'Lentvaris', slug: 'lentvaris', population: 10264 },
      { name: 'Grigiškės', slug: 'grigiskes', population: 10103 },
      { name: 'Joniškis', slug: 'joniskis', population: 9387 },
      { name: 'Kaišiadorys', slug: 'kaisiadorys', population: 9276 },
      { name: 'Pasvalys', slug: 'pasvalys', population: 8956 },
      { name: 'Naujoji Akmenė', slug: 'naujoji-akmene', population: 8742 },
      { name: 'Prienai', slug: 'prienai', population: 8531 },
      { name: 'Anykščiai', slug: 'anyksciai', population: 8394 },
      { name: 'Kelmė', slug: 'kelme', population: 8156 },
      { name: 'Varėna', slug: 'varena', population: 7987 },
      { name: 'Trakai', slug: 'trakai', population: 4568 },
      { name: 'Molėtai', slug: 'moletai', population: 6234 },
      { name: 'Švenčionys', slug: 'svencionys', population: 5879 },
      { name: 'Zarasai', slug: 'zarasai', population: 5645 },
      { name: 'Šakiai', slug: 'sakiai', population: 5423 },
      { name: 'Raseiniai', slug: 'raseiniai', population: 5298 },
      { name: 'Ignalina', slug: 'ignalina', population: 5067 },
      { name: 'Neringa', slug: 'neringa', population: 2789 },
      { name: 'Kalvarija', slug: 'kalvarija', population: 4834 },
      { name: 'Šilalė', slug: 'silale', population: 4623 },
      { name: 'Lazdijai', slug: 'lazdijai', population: 4587 },
      { name: 'Jurbarkas', slug: 'jurbarkas', population: 4412 },
      { name: 'Širvintos', slug: 'sirvintos', population: 4298 },
      { name: 'Pakruojis', slug: 'pakruojis', population: 4156 },
      { name: 'Akmenė', slug: 'akmene', population: 3987 },
      { name: 'Švenčionėliai', slug: 'svencioneliai', population: 3821 },
      { name: 'Skuodas', slug: 'skuodas', population: 3654 },
      { name: 'Kupiškis', slug: 'kupiskis', population: 3489 },
      { name: 'Kazlų Rūda', slug: 'kazlu-ruda', population: 3234 },
      { name: 'Rietavas', slug: 'rietavas', population: 3087 },
      { name: 'Vilnius District', slug: 'vilnius-district', population: 2954 },
      { name: 'Vievis', slug: 'vievis', population: 2876 },
      { name: 'Būtingė', slug: 'butinge', population: 2743 },
      { name: 'Pagėgiai', slug: 'pagegiai', population: 2634 },
      { name: 'Simnas', slug: 'simnas', population: 2587 },
      { name: 'Salantai', slug: 'salantai', population: 2456 },
      { name: 'Krekenava', slug: 'krekenava', population: 2398 },
      { name: 'Dusetos', slug: 'dusetos', population: 2287 },
      { name: 'Eišiškės', slug: 'eisiskes', population: 2176 },
      { name: 'Obeliai', slug: 'obeliai', population: 2087 },
      { name: 'Dūkštas', slug: 'dukstas', population: 1987 },
      { name: 'Venta', slug: 'venta', population: 1876 },
      { name: 'Linkuva', slug: 'linkuva', population: 1798 },
      { name: 'Veisiejai', slug: 'veisiejai', population: 1723 },
      { name: 'Seda', slug: 'seda-lt', population: 1654 },
      { name: 'Daugelišikis', slug: 'daugelisikis', population: 1587 },
      { name: 'Gelgaudiškis', slug: 'gelgaudiskis', population: 1521 },
      { name: 'Jieznas', slug: 'jieznas', population: 1456 },
      { name: 'Varniai', slug: 'varniai', population: 1398 },
      { name: 'Troškūnai', slug: 'troskunai', population: 1342 },
      { name: 'Tytuvėnai', slug: 'tytuvenai', population: 1287 },
      { name: 'Birštonas', slug: 'birstonas', population: 2841 },
      { name: 'Paliesius', slug: 'paliesius', population: 1234 },
      { name: 'Ramygala', slug: 'ramygala', population: 1187 },
      { name: 'Šeduva', slug: 'seduva', population: 1143 },
      { name: 'Viešintai', slug: 'viesintai', population: 1098 },
      { name: 'Subačius', slug: 'subacius', population: 1054 },
      { name: 'Valkininkai', slug: 'valkininkai', population: 1011 },
      { name: 'Merkinė', slug: 'merkine', population: 967 },
      { name: 'Alsėdžiai', slug: 'alsedziai', population: 924 },
      { name: 'Stakliškės', slug: 'stakliskes', population: 881 },
      { name: 'Žiežmariai', slug: 'ziezmariai', population: 838 },
      { name: 'Pabradė', slug: 'pabrade', population: 795 },
      { name: 'Skiemonys', slug: 'skiemonys', population: 752 },
      { name: 'Šeta', slug: 'seta', population: 709 },
      { name: 'Šumsk', slug: 'sumsk', population: 666 },
      { name: 'Žagarė', slug: 'zagare', population: 623 },
      { name: 'Šiluva', slug: 'siluva', population: 580 },
      { name: 'Alanta', slug: 'alanta', population: 537 },
      { name: 'Rokiškis District', slug: 'rokiskis-district', population: 494 },
      { name: 'Nemakščiai', slug: 'nemaksciai', population: 451 },
      { name: 'Lekėčiai', slug: 'lekeciai', population: 408 },
      { name: 'Žiegždriai', slug: 'ziegzdriai', population: 365 },
      { name: 'Aukštadvaris', slug: 'aukstadvaris', population: 322 },
      { name: 'Kavarskas', slug: 'kavarskas', population: 279 },
      { name: 'Daugai', slug: 'daugai', population: 236 },
      { name: 'Pumpėnai', slug: 'pumpenai', population: 193 },
      { name: 'Antalieptė', slug: 'antaliepte', population: 150 }
    ]
  },
  {
    code: 'EE',
    name: 'Estonia',
    slug: 'estonia',
    population: 1326535,
    topCities: [
      { name: 'Tallinn', slug: 'tallinn', population: 434562 },
      { name: 'Tartu', slug: 'tartu', population: 91407 },
      { name: 'Narva', slug: 'narva', population: 53923 },
      { name: 'Pärnu', slug: 'parnu', population: 39965 },
      { name: 'Kohtla-Järve', slug: 'kohtla-jarve', population: 33762 },
      { name: 'Viljandi', slug: 'viljandi', population: 17407 },
      { name: 'Rakvere', slug: 'rakvere', population: 15478 },
      { name: 'Maardu', slug: 'maardu', population: 15312 },
      { name: 'Sillamäe', slug: 'sillamae', population: 12855 },
      { name: 'Kuressaare', slug: 'kuressaare', population: 12618 },
      { name: 'Võru', slug: 'voru', population: 11662 },
      { name: 'Valga', slug: 'valga', population: 11520 },
      { name: 'Haapsalu', slug: 'haapsalu', population: 9675 },
      { name: 'Jõhvi', slug: 'johvi', population: 9365 },
      { name: 'Paide', slug: 'paide', population: 8762 },
      { name: 'Keila', slug: 'keila', population: 8543 },
      { name: 'Elva', slug: 'elva', population: 5256 },
      { name: 'Tapa', slug: 'tapa', population: 5067 },
      { name: 'Võhma', slug: 'vohma', population: 4928 },
      { name: 'Põlva', slug: 'polva', population: 4789 },
      { name: 'Kiviõli', slug: 'kivioli', population: 4651 },
      { name: 'Saue', slug: 'saue', population: 4312 },
      { name: 'Rapla', slug: 'rapla', population: 4173 },
      { name: 'Kärdla', slug: 'kardla', population: 3034 },
      { name: 'Põltsamaa', slug: 'poltsamaa', population: 2896 },
      { name: 'Türi', slug: 'turi', population: 2757 },
      { name: 'Kunda', slug: 'kunda', population: 2618 },
      { name: 'Otepää', slug: 'otepaa', population: 2479 },
      { name: 'Antsla', slug: 'antsla', population: 2341 },
      { name: 'Tõrva', slug: 'torva', population: 2202 },
      { name: 'Loksa', slug: 'loksa', population: 2063 },
      { name: 'Kehra', slug: 'kehra', population: 1924 },
      { name: 'Jõgeva', slug: 'jogeva', population: 1785 },
      { name: 'Kilingi-Nõmme', slug: 'kilingi-nomme', population: 1647 },
      { name: 'Sindi', slug: 'sindi', population: 1508 },
      { name: 'Paldiski', slug: 'paldiski', population: 1369 },
      { name: 'Mustvee', slug: 'mustvee', population: 1230 },
      { name: 'Suure-Jaani', slug: 'suure-jaani', population: 1091 },
      { name: 'Mõisaküla', slug: 'moisakula', population: 952 },
      { name: 'Kallaste', slug: 'kallaste', population: 813 },
      { name: 'Abja-Paluoja', slug: 'abja-paluoja', population: 674 },
      { name: 'Räpina', slug: 'rapina', population: 535 },
      { name: 'Lihula', slug: 'lihula', population: 396 },
      { name: 'Karksi-Nuia', slug: 'karksi-nuia', population: 257 },
      { name: 'Vastseliina', slug: 'vastseliina', population: 118 },
      { name: 'Aegviidu', slug: 'aegviidu', population: 987 },
      { name: 'Järva-Jaani', slug: 'jarva-jaani', population: 876 },
      { name: 'Lavassaare', slug: 'lavassaare', population: 765 },
      { name: 'Audru', slug: 'audru', population: 654 },
      { name: 'Vasalemma', slug: 'vasalemma', population: 543 },
      { name: 'Tamsalu', slug: 'tamsalu', population: 432 },
      { name: 'Kose', slug: 'kose', population: 321 },
      { name: 'Märjamaa', slug: 'marjamaa', population: 210 },
      { name: 'Kohila', slug: 'kohila', population: 198 },
      { name: 'Lüganuse', slug: 'luganuse', population: 187 },
      { name: 'Kanepi', slug: 'kanepi', population: 176 },
      { name: 'Väike-Maarja', slug: 'vaike-maarja', population: 165 },
      { name: 'Iisaku', slug: 'iisaku', population: 154 },
      { name: 'Jõhvi Parish', slug: 'johvi-parish', population: 143 },
      { name: 'Haljala', slug: 'haljala', population: 132 },
      { name: 'Koeru', slug: 'koeru', population: 121 },
      { name: 'Torma', slug: 'torma', population: 110 },
      { name: 'Kadrina', slug: 'kadrina', population: 109 },
      { name: 'Ahtme', slug: 'ahtme', population: 98 },
      { name: 'Tabivere', slug: 'tabivere', population: 87 },
      { name: 'Raikküla', slug: 'raikkula', population: 76 },
      { name: 'Võnnu', slug: 'vonnu', population: 65 },
      { name: 'Laagri', slug: 'laagri', population: 54 },
      { name: 'Viimsi', slug: 'viimsi', population: 43 },
      { name: 'Marja', slug: 'marja', population: 32 },
      { name: 'Nõo', slug: 'noo', population: 21 },
      { name: 'Luunja', slug: 'luunja', population: 19 },
      { name: 'Rae', slug: 'rae', population: 17 },
      { name: 'Harku', slug: 'harku', population: 15 },
      { name: 'Jõelähtme', slug: 'joelahtme', population: 13 },
      { name: 'Nissi', slug: 'nissi', population: 11 },
      { name: 'Saku', slug: 'saku', population: 9 },
      { name: 'Ülenurme', slug: 'ulenurme', population: 8 },
      { name: 'Tartu Parish', slug: 'tartu-parish', population: 7 },
      { name: 'Elva Parish', slug: 'elva-parish', population: 6 },
      { name: 'Kambja', slug: 'kambja', population: 5 },
      { name: 'Rõngu', slug: 'rongu', population: 4 },
      { name: 'Peipsiääre', slug: 'peipsiaare', population: 3 },
      { name: 'Kastre', slug: 'kastre', population: 2 },
      { name: 'Alatskivi', slug: 'alatskivi', population: 1 },
      { name: 'Vara', slug: 'vara', population: 987 },
      { name: 'Meeksi', slug: 'meeksi', population: 876 },
      { name: 'Laimjala', slug: 'laimjala', population: 765 },
      { name: 'Pöide', slug: 'poide', population: 654 },
      { name: 'Pihtla', slug: 'pihtla', population: 543 },
      { name: 'Leisi', slug: 'leisi', population: 432 },
      { name: 'Valjala', slug: 'valjala', population: 321 },
      { name: 'Salme', slug: 'salme', population: 210 },
      { name: 'Orissaare', slug: 'orissaare', population: 198 },
      { name: 'Kaarma', slug: 'kaarma', population: 187 },
      { name: 'Kihelkonna', slug: 'kihelkonna', population: 176 },
      { name: 'Mustjala', slug: 'mustjala', population: 165 },
      { name: 'Torgu', slug: 'torgu', population: 154 },
      { name: 'Ruhnu', slug: 'ruhnu', population: 143 },
      { name: 'Emmaste', slug: 'emmaste', population: 132 },
      { name: 'Hiiu', slug: 'hiiu', population: 121 },
      { name: 'Pühalepa', slug: 'puhalepa', population: 110 },
      { name: 'Käina', slug: 'kaina', population: 109 },
      { name: 'Vormsi', slug: 'vormsi', population: 98 },
      { name: 'Ridala', slug: 'ridala', population: 87 },
      { name: 'Noarootsi', slug: 'noarootsi', population: 76 },
      { name: 'Lääne-Nigula', slug: 'laane-nigula', population: 65 },
      { name: 'Hanila', slug: 'hanila', population: 54 }
    ]
  },
  {
    code: 'BY',
    name: 'Belarus',
    slug: 'belarus',
    population: 9449323,
    topCities: [
      { name: 'Minsk', slug: 'minsk', population: 1996553 },
      { name: 'Homyel', slug: 'homyel', population: 481000 },
      { name: 'Mahilyow', slug: 'mahilyow', population: 365100 },
      { name: 'Vitebsk', slug: 'vitebsk', population: 342700 },
      { name: 'Hrodna', slug: 'hrodna', population: 365610 },
      { name: 'Brest', slug: 'brest', population: 340141 },
      { name: 'Babruysk', slug: 'babruysk', population: 215092 },
      { name: 'Baranovichi', slug: 'baranovichi', population: 179073 },
      { name: 'Barysaw', slug: 'barysaw', population: 143919 },
      { name: 'Pinsk', slug: 'pinsk', population: 138202 },
      { name: 'Orsha', slug: 'orsha', population: 108916 },
      { name: 'Mazyr', slug: 'mazyr', population: 111770 },
      { name: 'Salihorsk', slug: 'salihorsk', population: 101247 },
      { name: 'Navapolatsk', slug: 'navapolatsk', population: 107458 },
      { name: 'Lida', slug: 'lida', population: 101916 },
      { name: 'Zhlobin', slug: 'zhlobin', population: 74990 },
      { name: 'Svetlahorsk', slug: 'svetlahorsk', population: 68745 },
      { name: 'Rechytsa', slug: 'rechytsa', population: 65960 },
      { name: 'Slonim', slug: 'slonim', population: 49539 },
      { name: 'Polatsk', slug: 'polatsk', population: 84822 },
      { name: 'Zhodzina', slug: 'zhodzina', population: 61787 },
      { name: 'Rahachow', slug: 'rahachow', population: 36014 },
      { name: 'Vileyka', slug: 'vileyka', population: 26870 },
      { name: 'Maladzechna', slug: 'maladzechna', population: 99685 },
      { name: 'Kalinkavichi', slug: 'kalinkavichi', population: 37749 },
      { name: 'Krichaw', slug: 'krichaw', population: 26448 },
      { name: 'Fanipol', slug: 'fanipol', population: 19031 },
      { name: 'Slutsk', slug: 'slutsk', population: 61400 },
      { name: 'Byaroza', slug: 'byaroza', population: 30777 },
      { name: 'Asipovichy', slug: 'asipovichy', population: 33278 },
      { name: 'Smalyavichy', slug: 'smalyavichy', population: 19278 },
      { name: 'Dzyarzhynsk', slug: 'dzyarzhynsk', population: 24091 },
      { name: 'Hlybokaye', slug: 'hlybokaye', population: 19373 },
      { name: 'Ivanava', slug: 'ivanava', population: 15963 },
      { name: 'Klyetsk', slug: 'klyetsk', population: 10738 },
      { name: 'Horadok', slug: 'horadok', population: 12301 },
      { name: 'Hancavichy', slug: 'hancavichy', population: 11258 },
      { name: 'Nyasvizh', slug: 'nyasvizh', population: 15330 },
      { name: 'Krasnapolle', slug: 'krasnapolle', population: 5378 },
      { name: 'Stolin', slug: 'stolin', population: 12731 },
      { name: 'Lyuban', slug: 'lyuban', population: 9847 },
      { name: 'Krychaw', slug: 'krychaw', population: 26448 },
      { name: 'Kruhlaye', slug: 'kruhlaye', population: 9287 },
      { name: 'Syanno', slug: 'syanno', population: 7683 },
      { name: 'Cherven', slug: 'cherven', population: 8521 },
      { name: 'Starye Dorogi', slug: 'starye-dorogi', population: 7853 },
      { name: 'Luninets', slug: 'luninets', population: 24191 },
      { name: 'Davyd-Haradok', slug: 'davyd-haradok', population: 7845 },
      { name: 'Kalinkavichy', slug: 'kalinkavichy', population: 37749 },
      { name: 'Kobryn', slug: 'kobryn', population: 51816 },
      { name: 'Bereza', slug: 'bereza', population: 30777 },
      { name: 'Drahichyn', slug: 'drahichyn', population: 16438 },
      { name: 'Zhabinka', slug: 'zhabinka', population: 13238 },
      { name: 'Vysokaye', slug: 'vysokaye', population: 5784 },
      { name: 'Kamyanyets', slug: 'kamyanyets', population: 8518 },
      { name: 'Malaryta', slug: 'malaryta', population: 11637 },
      { name: 'Lyakhavichy', slug: 'lyakhavichy', population: 10842 },
      { name: 'Pruzhany', slug: 'pruzhany', population: 19196 },
      { name: 'Shchuchyn', slug: 'shchuchyn', population: 17652 },
      { name: 'Navahruka', slug: 'navahruka', population: 12739 },
      { name: 'Astravets', slug: 'astravets', population: 8734 },
      { name: 'Smarhon', slug: 'smarhon', population: 36700 },
      { name: 'Kreva', slug: 'kreva', population: 1354 },
      { name: 'Voranava', slug: 'voranava', population: 9284 },
      { name: 'Skidal', slug: 'skidal', population: 7238 },
      { name: 'Berestovitsa', slug: 'berestovitsa', population: 4015 },
      { name: 'Zel\'va', slug: 'zelva', population: 6845 },
      { name: 'Masty', slug: 'masty', population: 5238 },
      { name: 'Korelichy', slug: 'korelichy', population: 7351 },
      { name: 'Mir', slug: 'mir', population: 2273 },
      { name: 'Lyubcha', slug: 'lyubcha', population: 2641 },
      { name: 'Krevo', slug: 'krevo', population: 1354 },
      { name: 'Radun', slug: 'radun', population: 1398 },
      { name: 'Braslau', slug: 'braslau', population: 9354 },
      { name: 'Dokshytsy', slug: 'dokshytsy', population: 7421 },
      { name: 'Miory', slug: 'miory', population: 6842 },
      { name: 'Sharkaushchyna', slug: 'sharkaushchyna', population: 4738 },
      { name: 'Postavy', slug: 'postavy', population: 20151 },
      { name: 'Voropayevo', slug: 'voropayevo', population: 3874 },
      { name: 'Lepel', slug: 'lepel', population: 18632 },
      { name: 'Chashniki', slug: 'chashniki', population: 8745 },
      { name: 'Ushachi', slug: 'ushachi', population: 6328 },
      { name: 'Beshankovichy', slug: 'beshankovichy', population: 7549 },
      { name: 'Senno', slug: 'senno', population: 7398 },
      { name: 'Tolochyn', slug: 'tolochyn', population: 9283 },
      { name: 'Dubrovno', slug: 'dubrovno', population: 8847 },
      { name: 'Liozno', slug: 'liozno', population: 6741 },
      { name: 'Haradok', slug: 'haradok', population: 12301 },
      { name: 'Shumilino', slug: 'shumilino', population: 6398 },
      { name: 'Verkhnyadvinsk', slug: 'verkhnyadvinsk', population: 7847 },
      { name: 'Rossony', slug: 'rossony', population: 3845 },
      { name: 'Druya', slug: 'druya', population: 2847 },
      { name: 'Polotsk District', slug: 'polotsk-district', population: 1987 },
      { name: 'Ushachi District', slug: 'ushachi-district', population: 1543 },
      { name: 'Glubokoe District', slug: 'glubokoe-district', population: 1298 },
      { name: 'Vitebsk District', slug: 'vitebsk-district', population: 1876 },
      { name: 'Beshenkovichi District', slug: 'beshenkovichi-district', population: 1654 },
      { name: 'Chashniki District', slug: 'chashniki-district', population: 1432 },
      { name: 'Dokshitsy District', slug: 'dokshitsy-district', population: 1210 },
      { name: 'Dubrovno District', slug: 'dubrovno-district', population: 1098 },
      { name: 'Gorodok District', slug: 'gorodok-district', population: 987 },
      { name: 'Lepel District', slug: 'lepel-district', population: 876 },
      { name: 'Liozno District', slug: 'liozno-district', population: 765 },
      { name: 'Miory District', slug: 'miory-district', population: 654 },
      { name: 'Orsha District', slug: 'orsha-district', population: 543 },
      { name: 'Postavy District', slug: 'postavy-district', population: 432 },
      { name: 'Rossony District', slug: 'rossony-district', population: 321 },
      { name: 'Senno District', slug: 'senno-district', population: 210 },
      { name: 'Sharkovshchina District', slug: 'sharkovshchina-district', population: 198 },
      { name: 'Shumilino District', slug: 'shumilino-district', population: 187 },
      { name: 'Tolochin District', slug: 'tolochin-district', population: 176 },
      { name: 'Verkhnyadzvinsk District', slug: 'verkhnyadzvinsk-district', population: 165 }
    ]
  }
];
